import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import { notification } from 'components/Notification'
import {
  NOTIFICATIONS,
  ResponseWithPagination,
  TOptionsWithNameResponse
} from '../../constants'
import {
  AllowedUsersDataResponse,
  FilterListResponse,
  TCommunityInfoForm
} from './types'

const fetcher = new Fetcher({})

export const getAllowedRoles = async () =>
  fetcher.request<unknown, AllowedUsersDataResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.ALLOWED_ROLES}`,
    method: HTTP_METHODS.GET
  })

export const getDepartmentsList = (hsId: string) =>
  fetcher.request<unknown, FilterListResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.HEALTH_SYSTEMS}${hsId}/${API_DICTIONARY.DEPARTMENTS}`,
    method: HTTP_METHODS.GET
  })

export const getHospitalsList = (hsId: string) =>
  fetcher.request<unknown, FilterListResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.HEALTH_SYSTEMS}${hsId}/${API_DICTIONARY.HOSPITALS}`,
    method: HTTP_METHODS.GET
  })

export const getDefaultDepartmentsListRequest = (communityId: string) =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsWithNameResponse>>({
    url: `${API_DICTIONARY.COMMUNITIES}${communityId}/${API_DICTIONARY.DEFAULT_DEPARTMENTS}`,
    method: HTTP_METHODS.GET
  })

export const updateCommunityInfo = async (
  data: TCommunityInfoForm,
  uuid: string
) =>
  fetcher.request<unknown, TCommunityInfoForm>({
    url: `${API_DICTIONARY.COMMUNITIES}${uuid}/`,
    method: HTTP_METHODS.PATCH,
    data: data,
    notification: notification,
    successMessage: NOTIFICATIONS.COMMUNITY_SAVED
  })

export const getCommunityInfo = async (uuid: string) =>
  fetcher.request<unknown, TCommunityInfoForm>({
    url: `${API_DICTIONARY.COMMUNITIES}${uuid}/`,
    method: HTTP_METHODS.GET
  })
